import React, { FC, ReactNode } from 'react';
import { Container, Heading, Description, StyledLinkContainer } from './UnavailableBox.styles';

interface UnavailableBoxProps {
  title: string | ReactNode;
  body: string | ReactNode;
  footer?: React.ReactNode;
}

export const UnavailableBox: FC<UnavailableBoxProps> = ({ title, body, footer }) => (
  <Container>
    <Heading>{title}</Heading>
    <Description>{body}</Description>
    {footer && <StyledLinkContainer>{footer}</StyledLinkContainer>}
  </Container>
);
